import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';

export const MaskContainer = styled(Box).attrs({
  bg: 'lightLineDivider',
  height: 50,
  width: '100%',
  p: '5px',
})`
  word-break: break-all;
  max-height: 50px;
`;
export const TextContainer = styled(Box).attrs({
  height: 50,
  width: '100%',
  align: 'center',
})`
  word-break: break-all;
`;
export const MaskedText = styled(Text).attrs({
  size: 'normal',
  bg: 'lightLineDivider',
})`
  visibility: hidden;
`;
